//cyq
import * as React from 'react';
import { axios_ } from '../../../tools/axios_';
import { connect } from 'react-redux';
import { DoubleRightOutlined } from '@ant-design/icons';
import { Table, Modal } from 'antd';
import { Link } from 'react-router-dom';
import './clientDetails.less';
import { initPageNamesConfig } from '../../../tools/utils';
import { idTypeList } from './index';
import { taiKangInsurancePolicyShow } from '../../../tools/utils'

let transThis;
const columnsFamily = [
  {
    title: '与本人关系',
    dataIndex: 'relationId',
    key: 'relationId',
  },
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    render: (text) => {
      return (
        <span>{ text === '2' ? '女' : text === '1' ? '男' : '未知' }</span>
      );
    }
  },
  {
    title: '年龄',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '证件类型',
    dataIndex: 'cidtypeId',
    key: 'cidtypeId',
    render: (text) => {
      return (
        <span>{ idTypeToName(text) }</span>
      );
    }
  },
  {
    title: '证件号码',
    dataIndex: 'cidno',
    key: 'cidno',
  },
  {
    title: '手机号码',
    dataIndex: 'mobile',
    key: 'mobile',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    render: (text, record) => {
      return (
        <span
          className="textButton"
          onClick={ () => {
            console.log(record);
            transThis.showModal();
            transThis.setState({
              familyInforDetail: record,
            });
          } }
        >查看详情</span>
      );
    },
    width: 100
  },
];

const columnsPolicy = [
  {
    title: '保险公司名称',
    dataIndex: 'orgCname',
    key: 'orgCname',
  },
  {
    title: '产品名称',
    dataIndex: 'spuName',
    key: 'spuName',
  },
  {
    title: '保单号',
    dataIndex: 'policyId',
    key: 'policyId',
    render:( text ) => <span>{taiKangInsurancePolicyShow(text)}</span>
  },
  {
    title: '保单生成时间',
    dataIndex: 'createdTime',
    key: 'createdTime',
  },
  {
    title: '投保人姓名',
    dataIndex: 'holderName',
    key: 'holderName',
  },
  {
    title: '被保人姓名',
    dataIndex: 'insuredName',
    key: 'insuredName',
  },
  {
    title: '保费',
    dataIndex: 'premium',
    key: 'premium',
    render: (text) => {
      return (<span>{ text ? (text - 0).toFixed(2) : '' }</span>);
    }
  },
  {
    title: '保单状态',
    dataIndex: 'policyStatus',
    key: 'policyStatus',
  },
];

class ClientDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      tableLoadingFamily: false,
      tableLoadingPolicy: false,
      baseInfo: {},//基本信息表
      affiliation: {},//归属信息表
      columnsFamily: columnsFamily,
      columnsPolicy: columnsPolicy,
      dataSourceFamily: [{ name: '王钢蛋' }],
      dataSourcePolicy: [],
      totals: 0, //保单
      current: 0,
      limit: 10,
      /*查询条件*/
      customerId: this.props.match.params.customerId,
      empno: this.props.match.params.empno === "undefined" ? "" : this.props.match.params.empno,
      company: this.props.match.params.company,
      groupName: this.props.match.params.groupName,
      agencyName: this.props.match.params.agencyName,
      /*家庭详情*/
      familyInforDetail: {},
      pageNamesConfig: {} // 页面字段配置
    };
  }
  componentDidMount() {
    // 初始化页面展示字段（合作案）
    initPageNamesConfig('clientManage', 'detail', this.props.token).then(res => {
      if (res.data.status === 200) {
        this.setState({ pageNamesConfig: res.data.data || {} });
      }
    });
    transThis = this;
    this.getList();
    this.getPolicyTableInfo(1, 10);
  }
  getList() {
    const {
      customerId,
      empno,
      company,
      groupName,
      agencyName,
    } = this.state;
    axios_({
      url: 'getCustomerInfoDetails',
      method: 'get',
      params: {
        customerId,
        empno,
        company,
        groupName,
        agencyName,
        type: 'MERCHANT'
      },
      headers: { 'access-token': this.props.token },
    }).then(res => {
      console.log(res.data);
      if (res.data.code === '200') {
        this.setState({
          baseInfo: res.data.result.baseInfo,
          affiliation: res.data.result.affiliation,
          dataSourceFamily: res.data.result.family,
          // dataSourcePolicy:res.data.result.policy,
        });
      }

    });
  }
  /*获取客户保单*/
  getPolicyTableInfo = (page, limit) => {
    const { } = this.state;
    axios_({
      url: "getCustomerPolicyInfo",
      method: 'get',
      params: {
        page: page,
        limit: limit,
        customerId: this.state.customerId,
      },
      headers: { 'access-token': this.props.token },
    }).then(res => {
      console.log(res);
      if (res.data.status === 200) {
        this.setState({
          dataSourcePolicy: res.data.data.rows,
          totals: res.data.data.total
        });
      }
    });
  };

  /*翻页--客户保单*/
  changePage = (current, pagesize) => {
    this.setState({ current });
    this.getPolicyTableInfo(current, pagesize);
  };
  onShowSizeChange = (current, pagesize) => {
    this.setState({
      pagesize,
      current: 1
    });
    this.getPolicyTableInfo(1, pagesize);
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  handleCancel = () => {
    this.setState({ visible: false });
  };

  render() {
    const {
      tableLoadingFamily,
      tableLoadingPolicy,
      columnsFamily,
      columnsPolicy,
      baseInfo,
      affiliation,
      dataSourceFamily,
      dataSourcePolicy,
      totals,
      current,
      visible,
      familyInforDetail,
    } = this.state;
    return (
      <div className="client_detail">
        <div className='header'>
          <Link className="backButton" to={ `/clientManage` }>返回客户列表 <DoubleRightOutlined /></Link>
        </div>
        <div className="main">
          {/*基本信息*/ }
          <div className="baseInfo">
            <header>基本信息</header>
            <table>
              <tbody>
                <tr>
                  <td>姓名</td>
                  <td>{ baseInfo.customerName || '' }</td>
                  <td>证件类型</td>
                  <td>{ idTypeToName(baseInfo.cidtypeId || "") }</td>
                </tr>
                <tr>
                  <td>性别</td>
                  <td>{ baseInfo.gender === '2' ? '女' : baseInfo.gender === '1' ? '男' : '未知' }</td>
                  <td>证件号码</td>
                  <td>{ baseInfo.cidno || '' }</td>
                </tr>
                <tr>
                  <td>年龄</td>
                  <td>{ baseInfo.age || '' } </td>
                  <td>电子邮箱</td>
                  <td>{ baseInfo.email || '' }</td>
                </tr>
                <tr>
                  <td>出生日期</td>
                  <td>{ baseInfo.birthday ? baseInfo.birthday.split(' ')[0] : '' }</td>
                  <td>地址</td>
                  <td>{ baseInfo.address || '' }</td>
                </tr>
                <tr>
                  <td>手机号码</td>
                  <td>{ baseInfo.mobile }</td>
                  <td>职业</td>
                  <td>{ baseInfo.professiondetail || '' }</td>
                </tr>
                <tr>
                  <td>客户来源</td>
                  <td>{ baseInfo.customerSource === 'P' ? '保单' : baseInfo.customerSource === 'A' ? '手工添加' : '' }</td>
                  <td>标签</td>
                  <td>{ baseInfo.labels ? baseInfo.labels.join('，') : '' }</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/*归属信息*/ }
          <div className="sourceInfo">
            <header>归属信息</header>
            <table>
              <tbody>
                <tr>
                  <td>{ this.state.pageNamesConfig.ofStaff || '归属业务员' }</td>
                  <td>{ affiliation.agencyName || '' }</td>
                  <td>{ this.state.pageNamesConfig.staffNo || '业务员工号' }</td>
                  <td>{ affiliation.empno || "" }</td>
                </tr>
                <tr>
                  <td>{ this.state.pageNamesConfig.ofCompany || '业务员机构' }</td>
                  <td>{ affiliation.company || "" }</td>
                  <td>{ this.state.pageNamesConfig.ofTeam || '业务员团队' }</td>
                  <td>{ affiliation.groupName }</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/*家庭成员*/ }
          <div className="familyInfo">
            <header>家属信息</header>
            <Table
              bordered
              size={ 'middle' }
              // rowKey='skuFeeStrategyId'
              rowKey={ (record, index) => (index) }
              loading={ tableLoadingFamily }
              columns={ columnsFamily }
              dataSource={ dataSourceFamily }
              pagination={ false }
            />
          </div>
          {/*客户保单*/ }
          <div className="policyInfo">
            <header>客户保单</header>
            <Table
              bordered
              size={ 'middle' }
              // rowKey='skuFeeStrategyId'
              rowKey={ (record, index) => (index) }
              loading={ tableLoadingPolicy }
              columns={ columnsPolicy }
              dataSource={ dataSourcePolicy }
              pagination={ {
                defaultPageSize: 10,
                showQuickJumper: true,
                onChange: this.changePage,
                total: totals,
                showTotal: (totals) => (`共 ${totals} 条`),
                current: current,
                showSizeChanger: true,
                onShowSizeChange: this.onShowSizeChange
              } }
            />
            <Modal
              // title="家庭成员详情"
              className='modalClass'
              maskClosable={ true }
              footer={ null }
              open={ visible }
              // onOk={this.handleOk}
              onCancel={ this.handleCancel }
              // confirmLoading={confirmLoading}
              wrapClassName='client_detail_wrap'
              width='860px'
            >
              <span className="test">家庭成员详情</span>
              <table className="modal_table">
                <tbody>
                  <tr>
                    <td>与本人关系</td>
                    <td>{ familyInforDetail.relationId || '' }</td>
                    <td>姓名</td>
                    <td>{ familyInforDetail.name }</td>
                  </tr>
                  <tr>
                    <td>性别</td>
                    <td>{ familyInforDetail.gender === '2' ? '女' : familyInforDetail.gender === '1' ? '男' : '未知' }</td>
                    <td>证件类型</td>
                    <td>{ idTypeToName(familyInforDetail.cidtypeId) }</td>
                  </tr>
                  <tr>
                    <td>年龄</td>
                    <td>{ familyInforDetail.age }</td>
                    <td>证件号码</td>
                    <td>{ familyInforDetail.cidno }</td>
                  </tr>
                  <tr>
                    <td>出生日期</td>
                    <td>{ familyInforDetail.birthday ? familyInforDetail.birthday.split(' ')[0] : '' }</td>
                    <td>电子邮箱</td>
                    <td>{ familyInforDetail.email }</td>
                  </tr>
                  <tr>
                    <td>手机号码</td>
                    <td>{ familyInforDetail.mobile }</td>
                    <td>地址</td>
                    <td>{ familyInforDetail.address }</td>
                  </tr>
                  <tr>
                    <td>职业</td>
                    <td>{ familyInforDetail.professiondetail }</td>
                    <td> </td>
                    <td> </td>
                  </tr>
                </tbody>
              </table>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
function idTypeToName(id) {
  let str = '';
  idTypeList.forEach(val => {
    if (id === val.value) {
      str = val.label;
    }
  });
  return str;
  // for(let i=0; i<idTypeList.length; i++){
  //   if(idTypeList[i].value===id){
  //     return idTypeList[i].label
  //   }
  // }
}
function mapState(state) {
  return {
    token: state.token
  };
}

export default connect(mapState)(ClientDetail);
